import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useRef, useState } from 'react'
import * as bie from "react-bootstrap";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, AllowFloats, handlePaste } from '../CommonUtils/CommonValidations';
import { BsEyeFill } from "react-icons/bs";
import { BiTrash } from "react-icons/bi";
import { VscDiffAdded } from "react-icons/vsc";
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import * as Yup from "yup";
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import { config } from '../CommonUtils/CommonURLS';
import { viewImage } from '../CommonUtils/viewImage';
import { ERROR_MSG } from '../CommonUtils/contextVariables';
import { GetCollegeType } from '../Reducers/AffiliationCommonservice';
import { ImagePdfBucket } from '../CommonUtils/ImagesBase64';
import { failureAlert, InfoAlert } from '../CommonUtils/SweetAlerts';
import CommonFormHeading from '../CommonUtils/CommonFormHeading';

export default function BuildBlock() {
  const Collegetype = useSelector((state) => state?.commonMastersReducer?.CollegeType);
  const [blockdata, setBlockdata] = useState([]);
  const hasFetchedData = useRef(false)
  const [BuildingReport, SetBuildingReport] = useState([]);
  const dispatch = useDispatch()
  const validationSchema = Yup.object().shape({
    instructionalArea: Yup.string().required(ERROR_MSG).nullable(),
    adminArea: Yup.string().required(ERROR_MSG).nullable(),
    amenitiesArea: Yup.string().required(ERROR_MSG).nullable(),
    accessCirculArea: Yup.string().required(ERROR_MSG).nullable(),


  });

  const BldformIk = useFormik({
    initialValues: {
      instructionalArea: "",
      adminArea: "",
      amenitiesArea: "",
      accessCirculArea: "",
      buildingblocks: [{
        buildBlockName: "",
        blockNo: "",
        noOfFloors: "",
        siteArea: [],
        campusType: "",
        buildingImg: "",
      },
      ],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => { submitDetails(values) },
  });

  function submitDetails(values) {
    const bb = values.buildingblocks;
    if (Array.isArray(bb) && bb.length > 0) {
      // Check all required fields in each block
      const incomplete = bb.some((block, idx) => {
        const {
          buildBlockName,
          blockNo,
          noOfFloors,
          siteArea,
          campusType,
          buildingImg,
        } = block;

        // 1. Determine if *any* field has been started
        const anyStarted = [
          buildBlockName,
          blockNo,
          noOfFloors,
          campusType,
          buildingImg,
        ].some(
          v => typeof v === 'string' && v.trim() !== ''
        ) || (Array.isArray(siteArea) && siteArea.length > 0);

        if (!anyStarted) {
          // Entire row blank → OK
          return false;
        }

        // 2. Validate that *all* required fields are non-empty
        const missingRequired =
          typeof buildBlockName !== 'string' ||
          buildBlockName.trim() === '' ||
          typeof blockNo !== 'string' ||
          blockNo.trim() === '' ||
          typeof noOfFloors !== 'string' ||
          noOfFloors.trim() === '' ||
          !Array.isArray(siteArea) ||
          siteArea.length === 0 ||
          typeof campusType !== 'string' ||
          campusType.trim() === '' ||
          typeof buildingImg !== 'string' ||
          buildingImg.trim() === '';

        return missingRequired;
      });

      if (incomplete) {
        InfoAlert('Please fill out all fields in each building block.');
      } else {
        if (Array.isArray(values.buildingblocks)) {
          values.buildingblocks = values.buildingblocks.filter(block => {
            // If buildBlockName is missing or blank, drop this block
            return (
              typeof block.buildBlockName === 'string' &&
              block.buildBlockName.trim() !== ''
            );
          });
        }

        let valid = true;
        values.buildingblocks.forEach((block, blockIndex) => {
          const noOfFloors = parseInt(values.buildingblocks[blockIndex]?.noOfFloors) || 0;
          const siteAreaLength = block.siteArea.length;
          if (siteAreaLength !== noOfFloors) {
            valid = false;
            console.log(`For block ${blockIndex + 1}, the number of siteArea fields doesn't match the number of floors.`);
          }
          block.siteArea.forEach((area, index) => {
            if (!area || isNaN(area) || parseFloat(area) <= 0) {
              valid = false;
              console.log(`Invalid siteArea for floor ${index + 1} in block ${blockIndex + 1}`);
            }
          });
        });
        if (!valid) {
          Swal.fire({
            text: 'Please ensure all Built-up Area fields are filled correctly.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          return;
        }

        values.buildingblocks.forEach(block => {
          block.siteArea = block.siteArea.map(area => parseInt(area, 10));
        });

        values.totalArea = parseInt(values.totalArea, 10);

        Swal.fire({
          text: 'Are you sure you want to submit?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, submit it!',
          cancelButtonText: 'No, cancel!',
          backdrop: false,
        }).then((result) => {
          if (result.isConfirmed) {
            let url = config.url.API_URL + 'afflbuildingblocks';
            CommonAxiosPost(url, values, dispatch).then((res) => {
              if (res?.data?.status === true) {
                Swal.fire(res?.data?.sdesc, '', 'success').then((res1) => {
                  if (res1?.isConfirmed) {
                    window.location.reload();
                  }
                });
              } else {
                failureAlert(res?.data?.sdesc);
              }
            }).catch((err) => {
            });
          }
        });
      }
    }


  }


  function Getdata() {
    let url = config.url.API_URL + `getbuildingblocks`
    CommonAxiosGet(url, dispatch).then(res => {
      if (res?.data?.scode === "01") {
        setBlockdata(res?.data?.building);
      }
      else {
        setBlockdata([]);
      }
    });
  }
  function BuildingBlockReport() {
    let url = config.url.API_URL + `getbldareadtls`
    CommonAxiosGet(url, dispatch).then(res => {
      if (res?.data?.scode == "01") {
        SetBuildingReport(res?.data?.buildingarea);
        BldformIk.setFieldValue("amenitiesArea", res?.data?.buildingarea[0]?.amenities_area)
        BldformIk.setFieldValue("adminArea", res?.data?.buildingarea[0]?.admin_area)
        BldformIk.setFieldValue("instructionalArea", res?.data?.buildingarea[0]?.instructional_area)
        BldformIk.setFieldValue("accessCirculArea", res?.data?.buildingarea[0]?.access_circul_area)
        BldformIk.setFieldValue("totalArea", res?.data?.buildingarea[0]?.total_area)
      }
      else {
        SetBuildingReport([]);
      }
    })
  }

  function sum() {
    const instructionalArea = parseFloat(BldformIk?.values?.instructionalArea) || 0;
    const adminArea = parseFloat(BldformIk?.values?.adminArea) || 0;
    const amenitiesArea = parseFloat(BldformIk?.values?.amenitiesArea) || 0;
    const accessCirculArea = parseFloat(BldformIk?.values?.accessCirculArea) || 0;
    const total = instructionalArea + adminArea + amenitiesArea + accessCirculArea;
    BldformIk?.setFieldValue("totalArea", total.toFixed(2));
  }

  function DeleteBuildingReport(sl_no) {
    Swal.fire({
      title: 'Are you sure want to Delete ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          slno: sl_no,
        }
        let url = config.url.API_URL + `deleteBuildingdtls`
        CommonAxiosPost(url, payload, dispatch).then(res => {
          if (res?.data?.scode === "01") {
            Swal.fire("Deleted Successfully", '', 'success').then((refresh) => {
              if (refresh.isConfirmed) {
                Getdata();
                window.location.reload(true)
              }
            });
          } else {
            failureAlert("Something went wrong,Please check");
          }
        }
        );

      }
    })
  }

  useEffect(() => {
    if (!hasFetchedData.current) {
      Getdata();
      BuildingBlockReport();
      GetCollegeType();
      hasFetchedData.current = true
    }
  }, [])

  return (
    <>
      <div className='affl-newdiv'>
        <bie.Container fluid className="px-1" >
          <FormikProvider value={BldformIk}>
            <Form onChange={BldformIk?.handleChange} onSubmit={BldformIk?.handleSubmit} className="affl-form" >
              <CommonFormHeading heading={"Building/Block Details"} />

              <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                <div className="inner-herbpage-service-title-sub pt-0"  >
                  <h1>Building Area Details ({Collegetype})</h1>
                </div>
                <bie.Row className="my-3 px-3">
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2}>
                    <bie.InputGroup >
                      <label className="label-text-style mb-1"><b className='mt-2' style={{ color: 'red' }}>* </b>Institutional Area</label>
                      <Field onKeyPress={(e) => { AllowFloats(e) }} type="text" name="instructionalArea" onPaste={(e) => handlePaste(e)}
                        className="form-control" onKeyUp={() => { sum(); }} style={{ width: "100px", Height: "100px" }} />
                      <ErrorMessage name="instructionalArea" component="div" className="text-error" />
                    </bie.InputGroup>
                  </bie.Col>

                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} className='mb-2'>
                    <bie.InputGroup>
                      <label className="label-text-style mb-1"><b className='mt-2' style={{ color: 'red' }}>* </b>Administrative Area</label>
                      <Field onKeyPress={(e) => { AllowFloats(e) }} type="text" name="adminArea" className="form-control" onKeyUp={() => { sum(); }}
                        onPaste={(e) => handlePaste(e)} />
                      <ErrorMessage name="adminArea" component="div" className="text-error" />
                    </bie.InputGroup>
                  </bie.Col>

                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} className='mb-3'>
                    <bie.InputGroup >
                      <label className="label-text-style mb-1"><b className='mt-2' style={{ color: 'red' }}>* </b>Amenities Area</label>
                      <Field onKeyPress={(e) => { AllowFloats(e) }} type="text" name="amenitiesArea" className="form-control"
                        onKeyUp={() => { sum(); }} onPaste={(e) => handlePaste(e)} />
                      <ErrorMessage name="amenitiesArea" component="div" className="text-error" />
                    </bie.InputGroup>
                  </bie.Col>
                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} className='mb-3' >
                    <bie.InputGroup>
                      <label className="label-text-style mb-1"><b className='mt-2' style={{ color: 'red' }}>* </b>Access & Circulation Area</label>
                      <Field onKeyPress={(e) => { AllowFloats(e) }} type="text" name="accessCirculArea" className="form-control" onKeyUp={() => { sum(); }}
                        onPaste={(e) => handlePaste(e)} />
                      <ErrorMessage name="accessCirculArea" component="div" className="text-error" />
                    </bie.InputGroup>
                  </bie.Col>

                  <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} className="mb-3">
                    <bie.InputGroup>
                      <label className="label-text-style mb-1">Total Built-up Area</label>
                      <Field type="text" name="totalArea" className="form-control" disabled />
                      <ErrorMessage name="totalArea" component="div" className="text-error" />
                    </bie.InputGroup>
                  </bie.Col>
                </bie.Row>

                <div className="inner-herbpage-service-title-sub pt-0"  >
                  <h1 className="">Building Block Details ({Collegetype})</h1>
                </div>
                {/* <bie.Alert variant="danger" className='affl-alert'>
                  <p className='mb-0'> <strong>Note:</strong> Survey No. will be populated from Society Land Allotment Details</p>
                </bie.Alert> */}
                <bie.Row className="px-2 my-3 ">
                  <div className="table-responsive">
                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                      <thead>
                        <tr>
                          <th> <label className="red-number">*</label>S.No </th>
                          <th> <label className="red-number">*</label>Block Number</th>
                          <th> <label className="red-number">*</label>Building / Block Name</th>
                          <th> <label className="red-number">*</label>No. of Floors</th>
                          <th> <label className="red-number">*</label>Built-up Area ({Collegetype})</th>
                          <th> <label className="red-number">*</label>Upload Building Block Image</th>
                          <th> <label className="red-number">*</label>Campus Type</th>
                          <th> Action</th>
                        </tr>
                      </thead>
                      <tbody style={{ textAlign: "center" }}>
                        <FieldArray name="buildingblocks">
                          {(Buildingvalues) => {
                            return Buildingvalues?.form?.values?.buildingblocks?.map((qual, index) => {
                              return (
                                <>
                                  <tr>
                                    <td>
                                      <center>{index + 1}</center>
                                    </td>

                                    <td >
                                      <Field onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength="3" onPaste={(e) => { handlePaste(e) }}
                                        type="text" className="form-control" name={`buildingblocks[${index}].blockNo`} />
                                      <ErrorMessage name={`buildingblocks[${index}].blockNo`} component="div" className="text-error" />
                                    </td>
                                    <td>
                                      <Field onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }}
                                        type="text" className="form-control" maxLength="30"
                                        name={`buildingblocks[${index}].buildBlockName`}
                                      />
                                      <ErrorMessage name={`buildingblocks[${index}].buildBlockName`} component="div" className="text-error" />
                                    </td>
                                    <td className="position-relative">
                                      <Field component="select" className="form-control" name={`buildingblocks[${index}].noOfFloors`}
                                        onChange={(e) => { Buildingvalues.form.setFieldValue(`buildingblocks[${index}].noOfFloors`, e.target.value); }}>
                                        <option value="">--select--</option>
                                        {[...Array(10).keys()].map((i) => (<option key={i} value={i + 1}>{i + 1}</option>))}
                                      </Field>
                                      <ErrorMessage name={`buildingblocks[${index}].noOfFloors`} component="div" className="text-error" />
                                    </td>
                                    <td>
                                      {Array.from(
                                        { length: parseInt(Buildingvalues?.form?.values?.buildingblocks[index]?.noOfFloors) || 0 },
                                        (_, floorIndex) => (
                                          <div key={floorIndex} className="mb-2">
                                            <Field onKeyPress={(e) => AllowFloats(e)} onPaste={(e) => handlePaste(e)}
                                              type="text" className="form-control" name={`buildingblocks[${index}].siteArea[${floorIndex}]`}
                                              placeholder={`Built-up Area for Floor ${floorIndex + 1}`} />
                                            <ErrorMessage name={`buildingblocks[${index}].siteArea[${floorIndex}]`} component="div" className="text-error" />
                                          </div>

                                        )
                                      )}
                                    </td>

                                    <td>
                                      <bie.InputGroup>
                                        <input type="file" className="form-control" name={`buildingblocks[${index}].buildingImg`} accept="image/*"
                                          onChange={(e) => {
                                            let filename = `buildingImg`
                                            let path = "/Uploads/BuildingImg/2024/"
                                            ImagePdfBucket(e, BldformIk, path, `buildingblocks[${index}].buildingImg`, filename, "image");
                                          }} />
                                        <Field type="hidden" name={`buildingblocks[${index}].buildingImg`} className="form-control" />
                                        <ErrorMessage name={`buildingblocks[${index}].buildingImg`} component="div" className="text-error" />
                                      </bie.InputGroup>
                                    </td>
                                    <td className="position-relative">
                                      <Field component="select" className="form-control " name={`buildingblocks[${index}].campusType`}>
                                        <option value="">--select--</option>
                                        <option value="off">Off Campus</option>
                                        <option value="main">Main Campus</option>
                                      </Field>
                                      <ErrorMessage name={`buildingblocks[${index}].campusType`} component="div" className="text-error" />
                                    </td>
                                    <td align="center">
                                      {index === 0 ? (
                                        <>
                                          <button type="button" className="button-titile btn btn-sm btn-success" onClick={() => {
                                            Buildingvalues.push({
                                              blockNo: "",
                                              buildBlockName: "",
                                              noOfFloors: "",
                                              siteArea: [],
                                              upload_buildingimage: "",
                                              buildingImg: "",
                                              campusType: "",

                                            });
                                          }}>
                                            <VscDiffAdded></VscDiffAdded>{" "}
                                          </button>
                                        </>) : ("")}
                                      {/* {index !== 0 && index === BldformIk?.values?.buildingblocks?.length - 1 ? ( */}

                                      {index > 0 && BldformIk?.values?.buildingblocks?.length > 1 ? (
                                        <>
                                          <button type="button" className="button-titile btn btn-sm btn-danger" onClick={() => {
                                            Buildingvalues?.remove(index);
                                          }}>
                                            <BiTrash></BiTrash>
                                          </button>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                  </tr>
                                </>
                              );
                            });
                          }}
                        </FieldArray>
                      </tbody>
                    </table>
                  </div>
                  <div className="d-grid gap-2 button-end">
                    <bie.Button variant="success" type="submit" className="btn_primary btn-sm float-end">Submit</bie.Button>
                  </div>
                  {blockdata && blockdata?.length > 0 && (
                    <bie.Row className="px-2 my-3">
                      <div className="table-responsive px-0">
                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Building / Block Name</th>
                              <th>No.of Floors</th>
                              <th>Built up Area({Collegetype})</th>
                              <th>Building Image</th>
                              <th>Campus Type</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody style={{ textAlign: "center" }}>
                            {blockdata !== undefined &&
                              blockdata.map((dep, i) => {
                                return (
                                  <>
                                    <tr>
                                      <td>{i + 1}</td>
                                      <td className='text-left'>{dep?.build_block_name}</td>
                                      <td>{dep?.no_of_floors}</td>
                                      <td>{dep?.site_area}</td>
                                      <td>{<button type='button' onClick={() => viewImage(dep?.building_img)} className='btn btn-primary'><BsEyeFill size={23}></BsEyeFill></button>}</td>
                                      <td>{dep?.campus_type}</td>
                                      <td><bie.Button type="button" className="btn btn-danger  btn-sm   pull-right"
                                        onClick={() => { DeleteBuildingReport(dep?.sl_no); }}><BiTrash />
                                      </bie.Button>
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </bie.Row>
                  )}

                  {BuildingReport && BuildingReport?.length > 0 && (
                    <>
                      <div className="inner-herbpage-service-title-sub p-0">
                        <h1 className="mb-0">Building Area Details Report</h1>
                      </div>
                      <bie.Row className="px-2 pt-3m-0 mx-1 pt-3 ">
                        <div className="table-responsive">
                          <table className="table table-condensed table-bordered table-striped table-sm  table-responsive affl-table">
                            <thead>
                              <tr>
                                <th>Instructional Area	</th>
                                <th>Administrative Area	</th>
                                <th>Amenities Area	</th>
                                <th>Access & Circulation Area	</th>
                                <th>Total Built-up Area ({Collegetype})</th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                              {BuildingReport !== undefined &&
                                BuildingReport.map((data, i) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{data?.instructional_area}</td>
                                        <td>{data?.admin_area}</td>
                                        <td>{data?.amenities_area}</td>
                                        <td>{data?.access_circul_area}</td>
                                        <td>{data?.total_area}</td>
                                      </tr>
                                    </>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </bie.Row>
                    </>
                  )}
                </bie.Row>
              </bie.Container></Form></FormikProvider></bie.Container>
      </div >
    </>
  )
}
